import React from "react";
import AccessTab from "./AccessTab";
import AdvancedTab from "./AdvancedTab";
import ApprovalPoliciesTab from "./ApprovalPoliciesTab";
import CostTab from "./CostTab";
import EmailTab from "./EmailTab";
import HarnessTab from "./HarnessTab";
import InstructionsTab from "./InstructionsTab";
import KnowledgeTab from "./KnowledgeTab";
import ModelTab from "./ModelTab";
import SkillsTab from "./SkillsTab";
import ToolsTab from "./ToolsTab";
import ValidationTab from "./ValidationTab";

export default function AgentConfigTabContent({ activeTab, tabPropsById }) {
  if (activeTab === "instructions") {
    return <InstructionsTab {...tabPropsById.instructions} />;
  }
  if (activeTab === "model") return <ModelTab {...tabPropsById.model} />;
  if (activeTab === "cost") return <CostTab {...tabPropsById.cost} />;
  if (activeTab === "tools") return <ToolsTab {...tabPropsById.tools} />;
  if (activeTab === "knowledge") {
    return <KnowledgeTab {...tabPropsById.knowledge} />;
  }
  if (activeTab === "skills") return <SkillsTab {...tabPropsById.skills} />;
  if (activeTab === "harness") return <HarnessTab {...tabPropsById.harness} />;
  if (activeTab === "approvalPolicies") {
    return <ApprovalPoliciesTab {...tabPropsById.approvalPolicies} />;
  }
  if (activeTab === "publicChat") {
    return <AccessTab {...tabPropsById.publicChat} />;
  }
  if (activeTab === "email") return <EmailTab {...tabPropsById.email} />;
  if (activeTab === "validation") {
    return <ValidationTab {...tabPropsById.validation} />;
  }
  if (activeTab === "advanced") {
    return <AdvancedTab {...tabPropsById.advanced} />;
  }
  return null;
}
